// extracted by mini-css-extract-plugin
module.exports = {"editor":"CommonStyle_editor__2bkxP","editorContainer":"CommonStyle_editorContainer___F2tc","notification":"CommonStyle_notification__knYkq"};